import { render } from "./MiscOptionInput.vue?vue&type=template&id=835a4e2c&scoped=true&ts=true"
import script from "./MiscOptionInput.vue?vue&type=script&lang=ts"
export * from "./MiscOptionInput.vue?vue&type=script&lang=ts"

import "./MiscOptionInput.vue?vue&type=style&index=0&id=835a4e2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835a4e2c"]])

export default __exports__